import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'rendez-vous',
    templateUrl: 'rendez-vous.component.html',
    styleUrls: ['rendez-vous.component.scss']
})
export class RendezVous implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<RendezVous>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
    }

    dismissDialog(){
        this.dialogRef.close();
    }
}